import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('auth', 'session-refresh');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users/sessions',
  type: 'put',
});

export default createReqReducer(consts);

// PUT /api/users/sessions



// WEBPACK FOOTER //
// ./src/redux/auth/session-refresh-req.js